import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import axios from "axios";
import config_settings from "../../../config/config";

let BASE_URL;

const origin = () => {
    let origin = window.location.origin.toLowerCase();
    if (origin.includes("https://")) origin = origin.replace("https://", "");
    else origin = origin.replace("http://", "");
    BASE_URL = config_settings[origin]?.SERVER_URL;
};

origin();

const CLDeleteRatings = ({
    setDeleteLoader,
    deleteLoader,
    handleCloseConfirmationModal,
    deleteConfirmationModal,
    deletedTagId,
    setDeletedTagId,
    isHTCompany,
    fetchRatings, // renamed prop from GetCommentLibTagList for clarity
    // Global ratings are shared across templates, so deleting one here reaches further than the
    // per-company rating it replaces — the warning says so.
    isGlobalRatingEnabled = false
}) => {
    const handleDeleteRating = async () => {
        if (!deletedTagId) return;

        setDeleteLoader(true);
        try {
            const companyID = sessionStorage.getItem("company-key");

            const response = await axios.delete(
                `${BASE_URL}/ratings/${deletedTagId}`,
                {
                    headers: {
                        "company-key": companyID
                    }
                }
            );

            if (response?.data?.success) {
                toast.success(response.data.message || "Rating deleted successfully.");
                handleCloseConfirmationModal();
                setDeletedTagId(null);
                fetchRatings(); // Refresh the table
            } else {
                toast.error("Failed to delete rating.");
            }
        } catch (error) {
            console.error("Delete error:", error);
            toast.error("An error occurred while deleting.");
        } finally {
            setDeleteLoader(false);
        }
    };

    return (
        <Dialog
            open={deleteConfirmationModal}
            onClose={handleCloseConfirmationModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="delete-alert-modal"
            disableScrollLock
            keepMounted
        >
            <DialogTitle id="alert-dialog-title">
                {"Confirm Deletion?"}
                <CloseIcon className="close-icon" onClick={handleCloseConfirmationModal} />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {isGlobalRatingEnabled ? (
                        <>
                            Are you sure you want to delete this rating?
                            <br />
                            It will be permanently removed from all the templates and comments it has been assigned.
                        </>
                    ) : (
                        "Are you sure you want to delete this Rating? It will also be removed from the comments it is assigned to."
                    )}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button className='options' onClick={handleCloseConfirmationModal}><span>No</span></Button>
                <LoadingButton loading={deleteLoader} className='add-new-btn' onClick={handleDeleteRating}><span>Yes</span></LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default CLDeleteRatings;
